import React from 'react';
export type BadgeVariant = 'success' | 'warning' | 'danger' | 'neutral' | 'info' | 'primary';
interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
  size?: 'sm' | 'md';
}
export function Badge({
  children,
  variant = 'neutral',
  className = '',
  size = 'md'
}: BadgeProps) {
  const variants = {
    success: 'bg-green-100 text-green-700 border-green-200',
    warning: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    danger: 'bg-red-100 text-red-700 border-red-200',
    neutral: 'bg-slate-100 text-slate-700 border-slate-200',
    info: 'bg-blue-100 text-blue-700 border-blue-200',
    primary: 'bg-orange-100 text-orange-700 border-orange-200'
  };
  const sizes = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-2.5 py-1 text-xs'
  };
  return <span className={`
      inline-flex items-center justify-center font-semibold rounded-full border 
      ${variants[variant]} 
      ${sizes[size]} 
      ${className}
    `} data-id="element-403">
      {children}
    </span>;
}